import { AxiosInstance } from 'axios';
import claimScoreApiServiceClient, {
  createClaimScoreApiClient,
} from './client';
import { ClaimScoreApiVersion } from './types';

export {
  CLAIMSCORE_API_URL,
  getAuthorizationToken,
  getBaseURLWithVersion,
} from './clientHelpers';

const versionedClientCache = new Map<ClaimScoreApiVersion, AxiosInstance>();

export const getClientForVersion = (
  version?: ClaimScoreApiVersion,
): AxiosInstance => {
  if (!version) {
    return claimScoreApiServiceClient;
  }

  const cached = versionedClientCache.get(version);
  if (cached) {
    return cached;
  }

  const client = createClaimScoreApiClient(version);
  versionedClientCache.set(version, client);
  return client;
};
